







































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class LoadingView extends Vue {
    // Properties:

    // Component Properties:
    @Prop({ required: false })
    public text?: string;

    @Prop({ required: false, default: 'middle-center' })
    public position!: 'top-left' | 'top-center' | 'middle-left' | 'middle-center';

    // Component Lifecycle:

    // Methods:
}
